import React from "react";

export default function CountdownTimer({
  hours,
  minutes,
  seconds,
  hoursLabel = "Hours",
  minutesLabel = "Minutes",
  secondsLabel = "Seconds",
  caption,
  className = "",
}) {
  const cells = [
    { value: hours, label: hoursLabel },
    { value: minutes, label: minutesLabel },
    { value: seconds, label: secondsLabel },
  ];

  return (
    <div
      className={`flex items-center gap-3 justify-center flex-wrap ${className}`}
    >
      {cells.map((c) => (
        <div
          key={c.label}
          className="flex flex-col items-center gap-1.5 flex-[1_1_68px] min-w-[64px] py-3.5 px-2 rounded-2xl bg-white border border-[#F7CFC5]"
        >
          <span className="font-bold text-[clamp(24px,6vw,30px)] leading-none text-brand-orange tabular-nums">
            {c.value}
          </span>
          <span className="sm:text-xs text-[10px] tracking-[0.08em] uppercase text-text-light">
            {c.label}
          </span>
        </div>
      ))}
      {caption && (
        <span className="text-sm text-text-light sm:max-w-[16ch] leading-[1.4] sm:flex-[1_1_120px] text-center sm:text-left">
          {caption}
        </span>
      )}
    </div>
  );
}
